'use strict';

angular.module('AcaApp').controller('ClientDisabledcontroller',
[
  function(){
  }
]);